import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Typography,
  Button,
  Box,
  Container
} from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { APP_NAME } from '../../constants';
import breakfastBackground from '../../imgs/breakfast.jpg';
import theme from '../../theme';
import { useLocale } from '../../i18n/LanguageContext';

const LoginWelcomeVerbiage = ({ embedded = false }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useLocale();
  const isRegisterPage = location.pathname === '/register';

  const handleRegisterClick = () => {
    navigate('/register');
  };

  const content = !isRegisterPage ? (
    <Box sx={{ 
      textAlign: 'center', 
      p: 6, 
      borderRadius: 2,
      backgroundImage: `url(${breakfastBackground})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      color: 'white'
    }}>
      <PersonAddIcon sx={{ fontSize: 60, mb: 2, textShadow: '0 2px 8px rgba(0, 0, 0, 0.65)' }} />
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', textShadow: '0 2px 10px rgba(0, 0, 0, 0.7)' }}>
        {t('login.welcomeVerbiage.title')}
      </Typography>
      <Typography variant="h6" sx={{ mb: 4, maxWidth: 600, mx: 'auto', textShadow: '0 2px 8px rgba(0, 0, 0, 0.7)', backgroundColor: 'rgba(0, 0, 0, 0.55)', px: 2.5, py: 1.5, borderRadius: 1 }}>
        {t('login.welcomeVerbiage.description', { appName: APP_NAME })}
      </Typography>
      <Button 
        data-testid="register-now-button"
        variant="contained" 
        size="large"
        onClick={handleRegisterClick}
        sx={{ 
          bgcolor: 'white', 
          color: theme.palette.secondary.main,
          px: 6,
          py: 1.5,
          fontSize: '1.1rem',
          fontWeight: 'bold',
          textTransform: 'none',
          '&:hover': {
            bgcolor: '#f5f5f5'
          }
        }}
      >
        {t('login.welcomeVerbiage.registerNow')}
      </Button>
    </Box>
  ) : null;

  if (embedded) {
    return content;
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {content}
    </Container>
  );
};

export default LoginWelcomeVerbiage;
